import { smartHttp, iStorage } from 'smart-core-util';
import { Toast } from 'mint-ui';
// import { Indicator } from 'mint-ui';
import config  from "./config"
class request {
    constructor() {

    }
    _iHttp() {
        return new smartHttp({
            baseURL: config.baseURL,
            alert: Toast,
            // block: Indicator.open,
            // unblock: Indicator.close
        }).api      
    }
    
}
export default new request()._iHttp();



// WEBPACK FOOTER //
// ./src/api/request.js